import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

export interface ICeilingHeightProps {
  value: number;
  onChange(value: number): void;
}

interface IValue {
  label: string;
  value: number;
}

const ALLOW_VALUES = [0, 2.5, 2.7, 3, 3.5, 4];

export const CeilingHeight: React.StatelessComponent<ICeilingHeightProps> = ({ value, onChange }) => {
  const values = ([
    { value: 0, label: 'Любая' },
    !ALLOW_VALUES.includes(value) && { value, label: `От ${value} м` },
    { value: 2.5, label: 'От 2,5 м' },
    { value: 2.7, label: 'От 2,7 м' },
    { value: 3, label: 'От 3 м' },
    { value: 3.5, label: 'От 3,5 м' },
    { value: 4, label: 'От 4 м' },
  ].filter(Boolean) as { value: number; label: string }[]).sort((a: IValue, b: IValue) => a.value - b.value);

  return <DropdownField value={value} onValueChange={onChange} values={values} />;
};
